<template>
  <div
    v-if="enabled"
    v-dompurify-html="infoText"
    class="info mt-4 max-w-full text-base"
  />
</template>

<script setup lang="ts">
const basket = await useFimBasket()
const { data: config, fetch: fetchConfig } = await useCustomData()

onMounted(async () => {
  await fetchConfig()
})

const price = computed(() => unref(basket?.cost)?.withTax ?? 0)

const freeShippingConfig = computed(() => config.value?.freeShipping)
const { isRxFreeShippingEnabled } = await useFeatureToggles()
const hasRxItemInBasket = computed(() =>
  basket.items.value?.find((item) => isRxMainItem(item)),
)

const enabled = computed(() => {
  if (isRxFreeShippingEnabled() && hasRxItemInBasket.value) {
    return false
  }
  return unref(price) <= (freeShippingConfig.value?.minBasketValue ?? 0)
})

const infoText = computed(() => {
  const diff = (freeShippingConfig.value?.minBasketValue ?? 0) - unref(price)

  if (diff > 0) {
    const value = toCurrency(diff)
    const text = unref(freeShippingConfig)?.shippingCostInformation ?? ''
    return text.replace(/\{\s*value\s*}/, value)
  }

  return undefined
})
</script>

<style scoped>
.info :deep(b) {
  font-weight: 500;
}
</style>
